/*
 * Copyright 2026 Sony Corporation
 */

/**
 * Who sees what.
 *
 * Babylon renders a mesh for a camera when `mesh.layerMask & camera.layerMask`
 * is non-zero. Camera rigs, their frustum lines and anything else the editor
 * draws to explain itself are annotations, not scenery — a camera preview must
 * show the world, not the furniture the editor put in it. Without this a rig
 * fills its own preview with the back of its lens.
 */

/** Babylon's default mesh mask: everything a scene loads. */
export const SCENE_LAYER = 0x0fffffff;

/** Editor annotations: rig bodies, lenses, frustum lines. */
export const RIG_LAYER = 0x10000000;

/** The viewport, which is the one camera that shows both. */
export const EDITOR_LAYER = SCENE_LAYER | RIG_LAYER;
